import { render, staticRenderFns } from "./fwMaterialCompare.vue?vue&type=template&id=5203e75c&scoped=true"
import script from "./fwMaterialCompare.vue?vue&type=script&lang=js"
export * from "./fwMaterialCompare.vue?vue&type=script&lang=js"
import style0 from "./fwMaterialCompare.vue?vue&type=style&index=0&id=5203e75c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5203e75c",
  null
  
)

export default component.exports